<template>
    <v-sheet :class="`main-banner main-banner-${random}`" v-if="banner && ((pc && detect == 'pc') || (mobile && detect == 'mobile'))">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <template v-for="(slide, index) in banner?.slides || []">
                    <div class="swiper-slide" :key="index">
                        <v-card :to="slide?.isOuterLink ? undefined : slide?.url" :href="slide?.isOuterLink ? slide?.url : undefined" :target="slide?.target" flat tile>
                            <!-- <v-img v-if="vertical" :src="slide?.image" :aspect-ratio="190 / 526" width="190" class="grey lighten-3" />
                            <v-img v-else :src="slide?.image" :aspect-ratio="1380 / 126" max-width="1380" class="w-100 mx-auto grey lighten-3" /> -->
                            <v-responsive :aspect-ratio="190 / 526" max-width="190" v-if="vertical">
                                <img :src="slide?.image" width="190" />
                            </v-responsive>
                            <v-responsive :aspect-ratio="1380 / 126" v-else>
                                <img :src="slide?.image" max-width="1380" class="w-100 mx-auto" />
                            </v-responsive>
                        </v-card>
                    </div>
                </template>
            </div>
        </div>
    </v-sheet>
    <!-- <v-sheet>
        <v-img v-if="vertical" :aspect-ratio="190 / 526" width="190" class="grey lighten-3"/>
        <v-img v-else :aspect-ratio="1380 / 126" max-width="1380" class="w-100 mx-auto grey lighten-3" />
    </v-sheet> -->
</template>

<script>
import api from "@/api";
import Swiper from "swiper/bundle";
import detect from "@/plugins/detect";

export default {
    props: {
        code: { type: String },

        pc: { type: Boolean, default: false },
        mobile: { type: Boolean, default: false },
        vertical: { type: Boolean, default: false },
    },
    data: () => ({
        random: Math.random().toFixed(10).slice(2, 12),

        detect,
        banner: null,
        swiper: undefined,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const { code } = this;
            let { banner } = await api.v1.banners.get({ code });
            this.banner = banner;

            this.$nextTick(() => {
                this.swiper = new Swiper(`.main-banner-${this.random} .swiper-container`, {
                    allowTouchMove: true,
                    centeredSlides: true,
                    spaceBetween: 24,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
